import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

/**
 * 霓虹蛇境 (Neon Snake Realm) - 应用入口
 *
 * 使用 React 18 的 createRoot API 挂载根组件。
 * StrictMode 用于在开发环境中捕获潜在问题。
 */

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    '无法找到根元素 #root。请检查 index.html 中是否包含 <div id="root"></div>。'
  );
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);